import { Form, Input, Select } from 'antd'
import React from 'react'

export const FormBase: React.FC = () => {
  return (
    <>
      <Form.Item label="Title" name="title" rules={[{ required: true }]}>
        <Input placeholder="Title" />
      </Form.Item>

      <Form.Item label="Key" name="key" rules={[{ required: true }]}>
        <Input placeholder="key" />
      </Form.Item>

      <Form.Item label="Type" name="type" rules={[{ required: true }]}>
        <Select
          placeholder="Select a type"
          options={[
            { label: 'Flow', value: 'FLOW' },
            { label: 'Onboarding', value: 'ONBOARDING' },
            // { label: 'Chat Form', value: 'UI_FORM' },
          ]}
        />
      </Form.Item>
    </>
  )
}
